function refreshToken(_vue, api_url)
{
	_vue.$http.get('token', {
		headers: {
			'Authorization': 'Bearer ' + _vue.$parent.$options.methods.token()
		}
	}).then(function (response) {
			_vue.$parent.$options.methods.saveArray('token', response.data.token);
		},
		function (response) {
			if(typeof response.data.error != 'undefined')
			{
				_vue.session_msg = response.data.error;
			}
		})
}

function getUrlParameter(sParam)
{
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
}

// Define what goes out when someone calls import
module.exports = {
	refreshToken: refreshToken,
	getUrlParameter: getUrlParameter
};
